import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import Profile from './Profile';
import Billing from './Billing';

const Account = () => {
  const { theme } = useTheme();

  return (
    <div className="flex flex-col h-[calc(100vh-64px)] p-2 md:p-4 space-y-2 md:space-y-4 w-[calc(100vw-16px)] overflow-y-auto">
      <div className={`flex flex-col md:flex-row gap-6 ${theme === 'light' ? 'text-gray-800' : 'text-gray-200'}`}>
        <div className="flex-1 min-w-0">
          <Billing />
        </div>
        <div className="flex-1 min-w-0">
          <Profile />
        </div>
      </div>
    </div>
  );
};

export default Account;
